import { NumberInput, NumberInputProps } from '@shared/components/NumberInput';
import { debounce } from 'lodash';
import { forwardRef, useCallback, useEffect, useState } from 'react';

interface TradingNumberInputProps extends NumberInputProps {
  handleTradeSizeUpdating?: (isUpdating: boolean) => void;
}

export const TradingNumberInput = forwardRef<HTMLDivElement, TradingNumberInputProps>((props, ref) => {
  const [displayValue, setDisplayValue] = useState<number | undefined>(props.value);

  const debouncedOnChange = useCallback(
    debounce((event: any, value: number | undefined) => {
      props.onChange(event, value);
    }, 50),
    [props.onChange]
  );

  const handleArrowClick = (event: any, value: number | undefined) => {
    setDisplayValue(value);
    props.handleTradeSizeUpdating?.(true);
    debouncedOnChange(event, value);
  };

  useEffect(() => {
    setDisplayValue(props.value);
    props.handleTradeSizeUpdating?.(false);
  }, [props.value]);

  return <NumberInput {...props} ref={ref} value={displayValue} onArrowClick={handleArrowClick} />;
});

TradingNumberInput.displayName = 'TradingNumberInput';
